@if (!hasAppointment()) {
  <hs-card [hsLayer]="'one'">
    <hs-card-body>
      <div class="flex flex-row w-full gap-4">
        @if (cardTitle) {
          <hs-icon [width]="32" [height]="32" [innerHTML]="cardIcon"></hs-icon>
        }
        <div hsCardTitle>{{ cardTitle }}</div>

        <span class="flex-1"></span>
        @if (isEditable()) {
          <button hsIconButton (click)="onNewAppointmentClicked()">
            <hs-icon [innerHTML]="iconNew"></hs-icon>
          </button>
        }
      </div>
    </hs-card-body>
  </hs-card>
} @else {
  <kfm-card [cardTitle]="cardTitle" [cardIcon]="cardIcon">
    <div class="flex flex-row gap-4">
      <hs-form-field>
        <hs-form-label>{{ dateFromLabel }}</hs-form-label>
        <hs-date-picker
          [value]="startDate()"
          [disabled]="!isEditable()"
          (dateChanged)="onStartDateChanged($event)"
        />
      </hs-form-field>

      <hs-form-field class="min-w-40">
        <hs-form-label>{{ timeFromLabel }}</hs-form-label>
        <hs-time-picker
          [value]="startTime()"
          [disabled]="!isEditable()"
          (timeChanged)="onStartTimeChanged($event)"
        />
      </hs-form-field>
    </div>

    <div class="flex flex-row gap-4">
      <hs-form-field>
        <hs-form-label>{{ dateToLabel }}</hs-form-label>
        <hs-date-picker
          [value]="endDate()"
          [disabled]="!isEditable()"
          (dateChanged)="onEndDateChanged($event)"
        />
      </hs-form-field>

      <hs-form-field class="min-w-40">
        <hs-form-label>{{ timeToLabel }}</hs-form-label>
        <hs-time-picker
          [value]="endTime()"
          [disabled]="!isEditable()"
          (timeChanged)="onEndTimeChanged($event)"
        />
      </hs-form-field>
    </div>
  </kfm-card>
}
